import React, { useState } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface TipsProps {
  title: string;
  content: React.ReactNode;
  buttonComponent?: React.ReactNode;
  iconColor?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /**
   * buttonComponent を包む Box に当てるスタイル。
   * このラッパーは flex 行の中では自身が flex アイテムになるので、
   * 中身を省略記号で切らせたい場合は minWidth:0 をここから渡すこと
   * (既定の min-width:auto のままだと縮まず、代わりに溢れる)。
   */
  buttonSx?: object;
}

const Tips: React.FC<TipsProps> = ({ title, content, buttonComponent, iconColor = 'rgba(255, 255, 255, 0.7)', maxWidth = 'xs', buttonSx }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {buttonComponent ? (
        <Box onClick={handleOpen} sx={buttonSx}>
          {buttonComponent}
        </Box>
      ) : (
        <IconButton onClick={handleOpen} size="small">
          <HelpOutlineIcon fontSize="small" sx={{ color: iconColor }} />
        </IconButton>
      )}
      <Dialog 
        open={open} 
        onClose={handleClose}
        fullWidth
        maxWidth={maxWidth}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '12px',
          },
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          {content}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>閉じる</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Tips;